import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE } from '../config';
import SeoHead from '../components/SeoHead';
import { PAGE_SEO } from '../constants/seo';
import { organizationSchema, websiteSchema } from '../constants/structuredData';
import './Page.css';

const Home = () => {
  const [currentSlide, setCurrentSlide]           = useState(0);
  const [isModalOpen, setIsModalOpen]             = useState(false);
  const [modalSubmitStatus, setModalSubmitStatus] = useState(null);
  const [isModalSubmitting, setIsModalSubmitting] = useState(false);
  const [activeService, setActiveService]         = useState(1);
  const [activeBenefit, setActiveBenefit]         = useState(0);
  const [activeWorkforce, setActiveWorkforce]     = useState(0);
  const [activeBlog, setActiveBlog]               = useState(0);
  const [activeChallenge, setActiveChallenge] = useState(0);

  const [formData, setFormData] = useState({
    name: '', number: '', email: '', city: '',
    companyName: '', employeeLocation: '',
    employeeCount: '', preferredTime: '', message: ''
  });

  /* ─── Data ─────────────────────────────────── */
  const sliderContent = [
    {
      title: "<strong>Affordable Employee <br/> Healthcare for MSMEs</strong>",
      description: "Anytime, Anywhere.",
      image: "/images/3slider.png",
      overlay: true, align: 'right', blueOverlay: true,
      buttonText: "Book a Demo", openModal: true
    },
    {
      title: "A One Stop Full-Stack<br />Employee Wellness<br />Platform",
      description: '&ldquo;Employee healthcare isn&rsquo;t an expenditure. It&rsquo;s a long-term investment in productivity, retention, and business growth.&rdquo;',
      image: "/images/forbusiness.png",
      overlay: true, align: 'left',
      buttonText: "Get Started", buttonLink: "/for-business", openModal: true
    },
    {
      title: "Unaffected Healthcare",
      description: "Give your members & their family Truly Unlimited Tele Consultation with certified doctors!",
      subtitle: "Anytime, Anywhere.",
      image: "/images/deb746_d7570f7ee4a745ed9d59c9d29e78ad2f~mv2.png",
      overlay: true, align: 'left',
      buttonText: "Get Started", openModal: true
    }
  ];

  const servicesSlider = [
    {
      title: "Order Medicines",
      description: "Upload your prescription and order genuine medicines online with fast and reliable home delivery.",
      icon: "/images/Medine.png"
    },
    {
      title: "Dental Benefits",
      description: "Access exclusive dental care benefits including check-ups, treatments, and preventive care for your entire family.",
      icon: "/images/Dental_benefits.png"
    },
    {
      title: "Doctor Consultations",
      description: "Connect with experienced doctors for online or in-person consultations and get professional medical advice anytime.",
      icon: "/images/Doctor_consultation.png"
    },
    {
      title: "Lab Test",
      description: "Book diagnostic lab tests from trusted centers with easy sample collection and quick, accurate results.",
      icon: "/images/Lab_test.png"
    },
    {
      title: "Employee Wellness",
      description: "Support employee well-being with stress management, mental wellness, and healthier work-life balance.",
      icon: "/images/18-Complete_Healthcare_Solutions_for_Your_Workforce.png"
    },
    {
      title: "Annual Health Checkup",
      description: "Monitor your employees health by providing Annual Health Checkup on discounted rates by NABL approved labs",
      icon: "/images/19-Complete_Healthcare_Solutions_for_Your_Workforce.png"
    }
  ];

  const benefits = [
    {
      title: "Increase Retention",
      description: "Increase your Employee retention by instilling crucial values as gifts, and enjoy the exceptional output they produce.",
      image: "/images/Title.png"
    },
    {
      title: "Long Term Success",
      description: "Success is a journey that spans years. Invest in the future with solutions that foster loyalty and dedication among your employees.",
      image: "/images/8.png"
    },
    {
      title: "Increase Profitability",
      description: "Invest in your employee well-being to ensure a healthier and more committed, leading to increased profitability and reduced attrition.",
      image: "/images/3.png"
    },
    {
      title: "Attract New Talent",
      description: "Stand out between the competition and attract new talents.",
      image: "/images/newtalent.png"
    }
  ];

  const workforceCards = [
    { img: "/images/workforce/t.webp",      alt: "White Collar", label: "For White Collars Employees", color: "blue"   },
    { img: "/images/workforce/blue.webp",   alt: "Blue Collar",  label: "For Blue Collars Employees",  color: "purple" },
    { img: "/images/workforce/grey.webp",   alt: "Grey Collar",  label: "For Grey Collars Employees",  color: "blue"   },
    { img: "/images/workforce/remote.webp", alt: "Remote",       label: "For Remote Employees",        color: "purple" },
    { img: "/images/workforce/hr.webp",     alt: "HR Leaders",   label: "For HR Leaders",              color: "blue"   }
  ];

  const blogPosts = [
    {
      title: "Is online doctor consultation truly reliable?",
      image: "/images/deb746_2028ecb63a4244bbb9a87fc1ed841ef1~mv2.webp"
    },
    {
      title: "Understanding Piles: Causes, Treatments, and Lifestyle Tips",
      image: "/images/11062b_81c1246e85784c3f9ed556ad2c9f353f~mv2.webp"
    },
    {
      title: "Ultimate Guide to lowering High Blood Pressure Through Diet, Exercise, Lifestyle Changes & Tracking high blood pressure at home",
      image: "/images/deb746_5f77bb64de0a426998af72bee495308d~mv2.webp"
    }
  ];

  const partnerLogos = [
    { name: "Clove Dental", src: "/images/Partner_Logo/1_clove_dental.jpeg" },
    { name: "Thyrocare", src: "/images/Partner_Logo/2_thyrocare_testsyoucantrust.jpeg" },
    { name: "TATA 1mg", src: "/images/Partner_Logo/3_tata1mg.jpeg" },
    { name: "Mahajan Diagnostics", src: "/images/Partner_Logo/4_mahajan_diagnostics.jpeg" },
    { name: "Medimaa", src: "/images/Partner_Logo/5_medimaa.jpeg" },
    { name: "Modern Diagnostics", src: "/images/Partner_Logo/6_modern.jpeg" },
    { name: "NABL certified laboratory", src: "/images/Partner_Logo/7nabl_certifiedlab.jpeg" }
  ];


  useEffect(() => {
    const t = setInterval(() => setActiveChallenge(p => (p + 1) % 4), 3500);
    return () => clearInterval(t);
  }, []);
  /* ─── Auto-slide intervals ──────────────────── */
  useEffect(() => {
    const t = setInterval(() => setCurrentSlide(p => (p + 1) % sliderContent.length), 5000);
    return () => clearInterval(t);
  }, [sliderContent.length]);

  useEffect(() => {
    const t = setInterval(() => setActiveService(p => (p + 1) % servicesSlider.length), 3000);
    return () => clearInterval(t);
  }, [servicesSlider.length]);

  useEffect(() => {
    const t = setInterval(() => setActiveBenefit(p => (p + 1) % benefits.length), 4000);
    return () => clearInterval(t);
  }, [benefits.length]);

  useEffect(() => {
    const t = setInterval(() => setActiveWorkforce(p => (p + 1) % workforceCards.length), 3000);
    return () => clearInterval(t);
  }, [workforceCards.length]);

  useEffect(() => {
    const t = setInterval(() => setActiveBlog(p => (p + 1) % blogPosts.length), 3000);
    return () => clearInterval(t);
  }, [blogPosts.length]);

  /* ─── Form handlers ─────────────────────────── */
  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setModalSubmitStatus(null);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsModalSubmitting(true);
    setModalSubmitStatus(null);
    try {
      const res  = await fetch(`${API_BASE}/api/get-started`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      const data = await res.json();
      if (data.success) {
        setModalSubmitStatus({ type: 'success', message: data.message });
        setFormData({ name: '', number: '', email: '', city: '', companyName: '', employeeLocation: '', employeeCount: '', preferredTime: '', message: '' });
        setTimeout(() => { setIsModalOpen(false); setModalSubmitStatus(null); }, 1500);
      } else {
        setModalSubmitStatus({ type: 'error', message: data.error || 'Something went wrong.' });
      }
    } catch {
      setModalSubmitStatus({ type: 'error', message: 'Unable to send. Please check your connection and try again.' });
    } finally {
      setIsModalSubmitting(false);
    }
  };

  const openModal  = () => { setIsModalOpen(true);  setModalSubmitStatus(null); };
  const closeModal = () => { setIsModalOpen(false); setModalSubmitStatus(null); };

  /* ─── Slider position helper ────────────────── */
  const getSliderClass = (index, active, total, prefix) => {
    const pos = (index - active + total) % total;
    if (pos === 0)       return `${prefix}--active`;
    if (pos === 1)       return `${prefix}--next`;
    if (pos === total-1) return `${prefix}--prev`;
    return `${prefix}--hidden`;
  };

  /* ══════════════════════════════════════════════ */
  return (
    <div className="page home-page">
      <SeoHead {...PAGE_SEO.home} jsonLd={[organizationSchema(), websiteSchema()]} />

      {/* ── Hero Slider ────────────────────────── */}
      <section className="hero-slider">
        <div className="slider-container">
          {sliderContent.map((slide, index) => (
            <div key={index} className={`slide ${index === currentSlide ? 'active' : ''}`}>
              <div
                className={`slide-background ${slide.overlay ? 'slide-overlay' : ''}`}
                style={{ background: !slide.overlay ? (slide.gradient || 'none') : 'none' }}
              >
                {slide.overlay && slide.image && (
                  <img src={slide.image} alt={slide.title} className="slide-bg-image mirror" />
                )}
                <div className="container">
                  <div className={`slide-content-wrapper ${slide.overlay ? 'slide-content-overlay' : ''}`}>
                    {slide.overlay && (
                      <>
                        {slide.blueOverlay && <div className="slide-blue-overlay" />}
                        <div className={`slide-content-overlay-wrapper slide-align-${slide.align || 'right'} ${slide.blueOverlay ? 'slide-blue-overlay-content' : ''}`}>
                          <div className="slide-content">
                            <h1 className="slide-title" dangerouslySetInnerHTML={{ __html: slide.title }} />
                            {slide.description && <p className="slide-description" dangerouslySetInnerHTML={{ __html: slide.description }} />}
                            {slide.subtitle && <p className="slide-subtitle">{slide.subtitle}</p>}
                            {slide.buttonText && (
                              slide.openModal
                                ? <button onClick={openModal} className="btn btn-primary slide-cta">{slide.buttonText} →</button>
                                : <Link to={slide.buttonLink || "/contact"} className="btn btn-primary slide-cta">{slide.buttonText} →</Link>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    {!slide.overlay && (
                      <>
                        <div className="slide-content">
                          <h1 className="slide-title">{slide.title}</h1>
                          {slide.description && <p className="slide-description">{slide.description}</p>}
                          {slide.subtitle && <p className="slide-subtitle">{slide.subtitle}</p>}
                          <Link to="/contact" className="btn btn-primary slide-cta">Connect Us →</Link>
                        </div>
                        <div className="slide-image">
                          {slide.image && <img src={slide.image} alt={slide.title} />}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="slider-dots">
          {sliderContent.map((_, i) => (
            <button key={i} className={`dot ${i === currentSlide ? 'active' : ''}`} onClick={() => setCurrentSlide(i)} />
          ))}
        </div>
      </section>

      {/* ── Hero Content ───────────────────────── */}
      <section className="hero-content-section">
        <div className="container">
          <h2 className="hero-content-title">Give the care your members deserve!</h2>
          <p className="hero-content-description">
            "Affordable primary healthcare designed for SMEs, helping detect health issues early, reduce up to 25% absenteeism, improve up to 30% productivity, and keep your members and their families healthy and supported."
          </p>
        </div>
      </section>


{/* ── Healthcare Challenges ─────────────────── */}
<section className="challenges-section">
  <div className="container">
    <h2 className="challenges-title">The <span className="challenges-highlight">Hidden cost of employee healthcare</span> in MSMEs</h2>
    <div className="challenges-grid">
      {[
        { icon: "/images/msme1.png", title: "No Healthcare Benefits", desc: "9 out of 10 MSMEs struggle to provide healthcare benefits" },
        { icon: "/images/msme2.png", title: "Impact on Productivity", desc: "MSMEs experience up to 30% productivity loss per employee", highlight: true },
        { icon: "/images/msme3.png", title: "25% Higher Absenteeism", desc: "MSMEs notice up to 25% higher absenteeism without healthcare access" },
        { icon: "/images/msme4.png", title: "Rising Insurance Premium", desc: "Lack of healthcare benefits accelerate the insurance premium on renewal", highlight: true }
      ].map((card, index) => (
        <div key={index} className={`challenge-card ${card.highlight ? 'challenge-card--highlight' : ''}`}>
          <div className="challenge-icon-wrap">
            <img src={card.icon} alt={card.title} className="challenge-icon" />
          </div>
          <h3 className="challenge-card-title">{card.title}</h3>
          <p className="challenge-card-desc">{card.desc}</p>
        </div>
      ))}
    </div>
    {/* Mobile slider */}
    <div className="challenges-mobile-slider">
      {[
        { icon: "/images/msme1.png", title: "No Healthcare Benefits", desc: "9 out of 10 MSMEs struggle to provide healthcare benefits" },
        { icon: "/images/msme2.png", title: "Impact on Productivity", desc: "MSMEs experience up to 30% productivity loss per employee", highlight: true },
        { icon: "/images/msme3.png", title: "25% Higher Absenteeism", desc: "MSMEs notice up to 25% higher absenteeism without healthcare access" },
        { icon: "/images/msme4.png", title: "Rising Insurance Premium", desc: "Lack of healthcare benefits accelerate the insurance premium on renewal", highlight: true }
      ].map((card, index) => {
        const total = 4;
        const pos = (index - activeChallenge + total) % total;
        let cls = "chlcard";
        if (pos === 0) cls += " chlcard--active";
        else if (pos === 1) cls += " chlcard--next";
        else if (pos === total - 1) cls += " chlcard--prev";
        else cls += " chlcard--hidden";
        return (
          <div key={index} className={`${cls} ${card.highlight ? 'chlcard--highlight' : ''}`} onClick={() => setActiveChallenge(index)}>
            <div className="chlcard-icon-wrap">
              <img src={card.icon} alt={card.title} className="chlcard-icon" />
            </div>
            <h3 className="chlcard-title">{card.title}</h3>
            <p className="chlcard-desc">{card.desc}</p>
          </div>
        );
      })}
    </div>
    <div className="challenges-mobile-controls">
      <button className="chlarrow" onClick={() => setActiveChallenge(p => (p - 1 + 4) % 4)}>←</button>
      <div className="chldots">
        {[0,1,2,3].map(i => (
          <button key={i} className={`chldot${i === activeChallenge ? ' chldot--active' : ''}`} onClick={() => setActiveChallenge(i)} />
        ))}
      </div>
      <button className="chlarrow" onClick={() => setActiveChallenge(p => (p + 1) % 4)}>→</button>
    </div>
  </div>
</section>






      {/* ── Services Slider ────────────────────── */}
      <section className="services-slider-section">
        <div className="container">
          <h2 className="services-slider-title">
            Complete Healthcare Solutions for Your Workforce
          </h2>
          <div className="slider-container2">
            {servicesSlider.map((service, index) => {
              const total    = servicesSlider.length;
              const position = (index - activeService + total) % total;
              let cls = "service-card";
              if (position === 0)       cls += " center";
              if (position === 1)       cls += " right";
              if (position === total-1) cls += " left";
              return (
                <div key={index} className={cls}>
                  <div className="icon-wrapper"><img src={service.icon} alt={service.title} /></div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ── Our Story ──────────────────────────── */}
      {/* <section className="story-section">
        <div className="container">
          <div className="story-content">
            <div className="story-text">
              <h2 className="section-title">Our Story</h2>
              <h3 className="story-subtitle">Get to Know Us</h3>
              <p>
                At Unaffected, we are on a relentless mission to transform healthcare in India.
                Our belief is simple: every individual deserves a high-quality life, with essential
                healthcare services. Yet, the reality is stark—many still lack access to even the
                most basic healthcare.
              </p>
              <Link to="/about" className="btn btn-primary">Read More</Link>
            </div>
            <div className="story-image">
              <img src="/images/our_story.png" alt="Woman Walking Outdoors" className="story-img" />
            </div>
          </div>
        </div>
      </section> */}


      {/* ── Onboarding ─────────────────────────── */}
      <section className="onboarding-section">
        <div className="container">
          <div className="onboarding-header">
            <p className="onboarding-kicker">How it works</p>
            <h2 className="onboarding-title">We made onboarding simple and fast</h2>
            <p className="onboarding-subtitle">
              Go live in minutes with a clear, guided setup—no back-and-forth, no complexity.
            </p>
          </div>
          <div className="onboarding-steps">
            <div className="onboarding-step">
              <div className="onboarding-step-number">01</div>
              <div className="onboarding-icon">
                <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#1f5f68" strokeWidth="2">
                  <rect x="4" y="3" width="16" height="18" rx="2" /><path d="M8 7h8M8 11h6M8 15h4" />
                </svg>
              </div>
              <p>Choose your plan</p>
            </div>
            <div className="onboarding-step">
              <div className="onboarding-step-number">02</div>
              <div className="onboarding-icon">
                <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#1f5f68" strokeWidth="2">
                  <circle cx="12" cy="8" r="4" /><path d="M4 21c2-4 6-6 8-6s6 2 8 6" />
                </svg>
              </div>
              <p>Submit Employees Details</p>
            </div>
            <div className="onboarding-step">
              <div className="onboarding-step-number">03</div>
              <div className="onboarding-icon">
                <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#1f5f68" strokeWidth="2">
                  <circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 3" />
                </svg>
              </div>
              <p>Quick Activation</p>
            </div>
            <div className="onboarding-step">
              <div className="onboarding-step-number">04</div>
              <div className="onboarding-icon">
                <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#1f5f68" strokeWidth="2">
                  <path d="M12 2l3 6 6 .5-4.5 4 1.5 6L12 16l-6 2.5 1.5-6L3 8.5 9 8z" />
                </svg>
              </div>
              <p>Enjoy your Services</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── Tagline ───────────────────────────── */}
      <section className="onboarding-tagline">
        <div className="container">
          <div className="onboarding-tagline-card">
            <p className="onboarding-tagline-pill">Try before you commit</p>
            <h2 className="onboarding-tagline-title">
              Experience <span>first</span>, subscribe later
            </h2>
          
          </div>
        </div>
      </section>

      {/* ── Quote ──────────────────────────────── */}
      <section
        className="quote-section"
        style={{
          background: `linear-gradient(rgba(0,0,0,0.4),rgba(0,0,0,0.4)), url('/images/11062b_6caa55abbc554025980bf4486598385f~mv2.jpg')`,
          backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' , display:'none'
        }}
      >
        <div className="container">
          <blockquote className="quote-text">"The first wealth is health"</blockquote>
          <p className="quote-author">Unaffected Healthcare</p>
        </div>
      </section>

      {/* ── Benefits Section ───────────────────── */}
      {/* <section className="benefits-section benefits-section-new">
        <div className="container">
          <div className="benefits-layout">

            {/* Left text — always visible */}
            {/* <div className="benefits-left-content">
              <h2 className="benefits-section-title">Unaffected Healthcare</h2>
              <p className="benefits-section-description">
                Increase your <strong>Employee</strong> retention by instilling crucial values as gifts, and enjoy the exceptional output they produce.
              </p>
              <button onClick={openModal} className="btn-benefits-connect">Connect Us →</button>
            </div> */}

            {/* Desktop: staggered two-column (hidden on mobile via CSS) */}
            {/* <div className="benefits-cards-staggered">
              <div className="benefits-cards-col benefits-cards-col-left">
                {benefits.filter((_, i) => i % 2 === 0).map(benefit => (
                  <div key={benefit.title} className="benefit-card-new">
                    <div className="benefit-card-image-wrap">
                      {benefit.image
                        ? <img src={benefit.image} alt={benefit.title} className="benefit-card-img" />
                        : <div className="benefit-card-image-placeholder" />}
                    </div>
                    <div className="benefit-card-body">
                      <h3 className="benefit-card-title">{benefit.title}</h3>
                      <p className="benefit-card-description">{benefit.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="benefits-cards-col benefits-cards-col-right">
                {benefits.filter((_, i) => i % 2 === 1).map(benefit => (
                  <div key={benefit.title} className="benefit-card-new">
                    <div className="benefit-card-image-wrap">
                      {benefit.image
                        ? <img src={benefit.image} alt={benefit.title} className="benefit-card-img" />
                        : <div className="benefit-card-image-placeholder" />}
                    </div>
                    <div className="benefit-card-body">
                      <h3 className="benefit-card-title">{benefit.title}</h3>
                      <p className="benefit-card-description">{benefit.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div> */}

            {/* Mobile: slider (hidden on desktop via CSS) */}
            {/* <div className="benefits-mobile-slider">
              <div className="benefits-mobile-track">
                {benefits.map((benefit, index) => {
                  const cls = `bmcard ${getSliderClass(index, activeBenefit, benefits.length, 'bmcard')}`;
                  return (
                    <div key={benefit.title} className={cls} onClick={() => setActiveBenefit(index)}>
                      <div className="bmcard-image">
                        {benefit.image
                          ? <img src={benefit.image} alt={benefit.title} />
                          : <div className="bmcard-image-placeholder" />}
                      </div>
                      <div className="bmcard-body">
                        <h3 className="bmcard-title">{benefit.title}</h3>
                        <p className="bmcard-desc">{benefit.description}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="benefits-mobile-controls">
                <button className="bmarrow" onClick={() => setActiveBenefit(p => (p - 1 + benefits.length) % benefits.length)}>←</button>
                <div className="bmdots">
                  {benefits.map((_, i) => (
                    <button key={i} className={`bmdot${i === activeBenefit ? ' bmdot--active' : ''}`} onClick={() => setActiveBenefit(i)} />
                  ))}
                </div>
                <button className="bmarrow" onClick={() => setActiveBenefit(p => (p + 1) % benefits.length)}>→</button>
              </div>
            </div> */}

          {/* </div> */}
        {/* </div> */}
      {/* </section> */} 

      {/* ── Modern Workforce ───────────────────── */}
      <section className="impact-section">
        <div className="container">
          <h2 className="impact-title">
            Real Business <span>Impact</span>
          </h2>

          <div className="impact-grid">
            <div className="impact-card">
              <div className="impact-icon impact-icon--green" aria-hidden="true">
                <svg viewBox="0 0 64 64" role="img" focusable="false">
                  <path d="M30 6h4v32h10L32 54 20 38h10V6z" fill="currentColor" />
                  <path d="M44 10c7 0 12 5 12 12s-5 12-12 12c-1 0-2 0-3-.3v-4.1c1 .3 2 .4 3 .4 4.8 0 8.6-3.9 8.6-8.6S48.8 12.8 44 12.8c-4.8 0-8.6 3.9-8.6 8.6h-4.2C31.2 14.1 36.8 10 44 10z" fill="currentColor" opacity="0.8" />
                  <text x="41" y="26" fontSize="12" fontWeight="700" fill="currentColor">₹</text>
                </svg>
              </div>
              <p className="impact-text">Reduce healthcare cost per employee</p>
            </div>

            <div className="impact-card">
              <div className="impact-icon impact-icon--amber" aria-hidden="true">
                <svg viewBox="0 0 64 64" role="img" focusable="false">
                  <path d="M14 50c0-8 8-14 18-14s18 6 18 14" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
                  <circle cx="24" cy="26" r="8" fill="none" stroke="currentColor" strokeWidth="4"/>
                  <circle cx="40" cy="26" r="8" fill="none" stroke="currentColor" strokeWidth="4" opacity="0.55"/>
                  <path d="M18 12h16" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
                  <circle cx="22" cy="12" r="6" fill="none" stroke="currentColor" strokeWidth="4"/>
                  <path d="M41 8l10 10M51 8L41 18" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
                </svg>
              </div>
              <p className="impact-text">Minimize absenteeism and downtime</p>
            </div>

            <div className="impact-card">
              <div className="impact-icon impact-icon--teal" aria-hidden="true">
                <svg viewBox="0 0 64 64" role="img" focusable="false">
                  <path d="M14 50V34" stroke="currentColor" strokeWidth="6" strokeLinecap="round"/>
                  <path d="M28 50V26" stroke="currentColor" strokeWidth="6" strokeLinecap="round" opacity="0.85"/>
                  <path d="M42 50V18" stroke="currentColor" strokeWidth="6" strokeLinecap="round" opacity="0.7"/>
                  <path d="M10 50h48" stroke="currentColor" strokeWidth="4" strokeLinecap="round" opacity="0.4"/>
                  <path d="M42 18l12-8v10" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M53 12C45 28 33 34 20 36" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
                </svg>
              </div>
              <p className="impact-text">Improve workforce productivity</p>
            </div>

            <div className="impact-card">
              <div className="impact-icon impact-icon--pink" aria-hidden="true">
                <svg viewBox="0 0 64 64" role="img" focusable="false">
                  <path
                    d="M32 54s-18-10.7-22.5-24C6 19 13.5 12 22 14.5c4.2 1.2 7 4.4 10 8 3-3.6 5.8-6.8 10-8C50.5 12 58 19 54.5 30 50 43.3 32 54 32 54z"
                    fill="currentColor"
                    opacity="0.85"
                  />
                </svg>
              </div>
              <p className="impact-text">Increase employee satisfaction and retention</p>
            </div>
          </div>

          <p className="impact-footer">
            Healthier employees build <span>stronger businesses</span>
          </p>
        </div>
      </section>

      <section className="advantage-section">
        <div className="container">
          <div className="advantage-wrap">
            <h2 className="advantage-title">The Unaffected Healthcare Advantage</h2>

            <div className="advantage-table" role="table" aria-label="Unaffected vs Others comparison">
              <div className="advantage-row advantage-row--head" role="row">
                <div className="advantage-cell advantage-cell--uh" role="columnheader">Unaffected Healthcare</div>
                <div className="advantage-cell advantage-cell--others" role="columnheader">Others</div>
              </div>

              {[
                ["Simple & Accessible", "Complex Process"],
                ["Dedicated for SME’s", "Not Dedicated for SME’s"],
                ["Affordable Pricings", "High End Pricings"],
                ["Experience First", "Subscribe First"],
                ["Proven Savings for Employees", "Standard Pricing"]
              ].map(([left, right], idx) => (
                <div className="advantage-row" role="row" key={idx}>
                  <div className="advantage-cell advantage-cell--left" role="cell">
                    {left}
                  </div>
                  <div className="advantage-cell advantage-cell--right" role="cell">
                    {right}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="modern-workforce-v2">
        <div className="container">

          {/* Desktop: ROW 1 (hidden on mobile via CSS) */}
          <div className="modern-row">
            <div className="modern-text-block">
              <h2>Build for Modern <br /><span>Workforce</span></h2>
              <button onClick={openModal} className="modern-connect-btn">Connect</button>
            </div>
            <div className="modern-square blue">
              <div className="icon-circle"><img src="/images/workforce/t.webp" alt="White Collar" /></div>
              <p>For White Collars Employees</p>
            </div>
            <div className="modern-square purple">
              <div className="icon-circle"><img src="/images/workforce/blue.webp" alt="blue Collar" /></div>
              <p>For Blue Collars Employees</p>
            </div>
          </div>

          {/* Desktop: ROW 2 (hidden on mobile via CSS) */}
          <div className="modern-row">
            <div className="modern-square blue">
              <div className="icon-circle"><img src="/images/workforce/grey.webp" alt="grey Collar" /></div>
              <p>For Grey Collars Employees</p>
            </div>
            <div className="modern-square purple">
              <div className="icon-circle"><img src="/images/workforce/remote.webp" alt="remote Collar" /></div>
              <p>For Remote Employees</p>
            </div>
            <div className="modern-square blue">
              <div className="icon-circle"><img src="/images/workforce/hr.webp" alt="hr Collar" /></div>
              <p>For HR Leaders</p>
            </div>
          </div>

          {/* Mobile: slider (hidden on desktop via CSS) */}
          <div className="workforce-mobile-slider">
            <div className="workforce-mobile-header">
              <h2>Built for Modern <br /><span>Workforce</span></h2>
              <button onClick={openModal} className="modern-connect-btn">Connect Us →</button>
            </div>
            <div className="workforce-mobile-track">
              {workforceCards.map((card, index) => {
                const cls = `wmcard ${card.color} ${getSliderClass(index, activeWorkforce, workforceCards.length, 'wmcard')}`;
                return (
                  <div key={card.label} className={cls} onClick={() => setActiveWorkforce(index)}>
                    <div className="wmcard-icon"><img src={card.img} alt={card.alt} /></div>
                    <p>{card.label}</p>
                  </div>
                );
              })}
            </div>
            <div className="workforce-mobile-controls">
              <button className="wmarrow" onClick={() => setActiveWorkforce(p => (p - 1 + workforceCards.length) % workforceCards.length)}>←</button>
              <div className="wmdots">
                {workforceCards.map((_, i) => (
                  <button key={i} className={`wmdot${i === activeWorkforce ? ' wmdot--active' : ''}`} onClick={() => setActiveWorkforce(i)} />
                ))}
              </div>
              <button className="wmarrow" onClick={() => setActiveWorkforce(p => (p + 1) % workforceCards.length)}>→</button>
            </div>
          </div>

        </div>
      </section>


      {/* ── Blog / Untold Stories ──────────────── */}
      <section className="partners-strip">
        <div className="container">
          <div className="partners-strip-head">
            <h2 className="partners-strip-title">Partnering with Industry Leaders</h2>
            <p className="partners-strip-desc">
              We collaborate with the best in the industry to ensure uncompromising service quality and flawless results
            </p>
          </div>

          <div className="partners-marquee" aria-label="Industry partners">
            <div className="partners-marquee-fade partners-marquee-fade--left" aria-hidden="true" />
            <div className="partners-marquee-fade partners-marquee-fade--right" aria-hidden="true" />

            <div className="partners-marquee-track">
              {[...partnerLogos, ...partnerLogos].map((logo, idx) => (
                <div className="partner-logo" key={`${logo.name}-${idx}`}>
                  <img src={logo.src} alt={logo.name} loading="lazy" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="blog-section">
        <div className="container">
          <h2 className="section-title">Untold Stories</h2>

          {/* Desktop: 3-column grid (hidden on mobile via CSS) */}
          <div className="blog-grid">
            {blogPosts.map((post, index) => (
              <article key={index} className="blog-card">
                <div className="blog-image"><img src={post.image} alt={post.title} /></div>
                <h3 className="blog-title">{post.title}</h3>
                <Link to="/blog" className="blog-read-more">Read More →</Link>
              </article>
            ))}
          </div>

          {/* Mobile: slider (hidden on desktop via CSS) */}
          <div className="blog-mobile-slider">
            <div className="blog-mobile-track">
              {blogPosts.map((post, index) => {
                const cls = `blcard ${getSliderClass(index, activeBlog, blogPosts.length, 'blcard')}`;
                return (
                  <article key={index} className={cls} onClick={() => setActiveBlog(index)}>
                    <div className="blcard-image"><img src={post.image} alt={post.title} /></div>
                    <div className="blcard-body">
                      <h3 className="blcard-title">{post.title}</h3>
                      <Link to="/blog" className="blog-read-more">Read More →</Link>
                    </div>
                  </article>
                );
              })}
            </div>
            <div className="blog-mobile-controls">
              <button className="blarrow" onClick={() => setActiveBlog(p => (p - 1 + blogPosts.length) % blogPosts.length)}>←</button>
              <div className="bldots">
                {blogPosts.map((_, i) => (
                  <button key={i} className={`bldot${i === activeBlog ? ' bldot--active' : ''}`} onClick={() => setActiveBlog(i)} />
                ))}
              </div>
              <button className="blarrow" onClick={() => setActiveBlog(p => (p + 1) % blogPosts.length)}>→</button>
            </div>
          </div>

        </div>
      </section>

      {/* ── Modal ──────────────────────────────── */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>×</button>
            <div className="blog-form-wrapper">
              <div className="blog-form-header">
                <h2>Submit the details.</h2>
                <p>Our team will reach you shortly.</p>
              </div>
              <form className="blog-contact-form" onSubmit={handleSubmit}>
                {modalSubmitStatus && (
                  <div className={`form-status form-status-${modalSubmitStatus.type}`} role="alert">
                    {modalSubmitStatus.message}
                  </div>
                )}
                <div className="form-group">
                  <label htmlFor="modal-name">Add your Name</label>
                  <input type="text" id="modal-name" name="name" value={formData.name} onChange={handleChange} required placeholder="Your full name" />
                </div>
                <div className="form-group">
                  <label htmlFor="modal-number">Add your Number</label>
                  <input type="tel" id="modal-number" name="number" value={formData.number} onChange={handleChange} required placeholder="Your phone number" />
                </div>
                <div className="form-group">
                  <label htmlFor="modal-email">Add your Email</label>
                  <input type="email" id="modal-email" name="email" value={formData.email} onChange={handleChange} required placeholder="your.email@example.com" />
                </div>
                <div className="form-group">
                  <label htmlFor="modal-city">Add your City</label>
                  <input type="text" id="modal-city" name="city" value={formData.city} onChange={handleChange} required placeholder="Your city" />
                </div>
                <div className="form-group">
                  <label htmlFor="modal-companyName">Company Name</label>
                  <input type="text" id="modal-companyName" name="companyName" value={formData.companyName} onChange={handleChange} required placeholder="Your company name" />
                </div>
                <div className="form-group">
                  <label htmlFor="modal-employeeLocation">Employee Location</label>
                  <input type="text" id="modal-employeeLocation" name="employeeLocation" value={formData.employeeLocation} onChange={handleChange} required placeholder="City / Region of employees" />
                </div>
                <div className="form-group">
                  <label htmlFor="modal-employeeCount">Employee Count</label>
                  <input type="number" id="modal-employeeCount" name="employeeCount" value={formData.employeeCount} onChange={handleChange} required min="1" placeholder="Number of employees" />
                </div>
                <div className="form-group">
                  <label htmlFor="modal-preferredTime">Preferable time to connect</label>
                  <input type="text" id="modal-preferredTime" name="preferredTime" value={formData.preferredTime} onChange={handleChange} required placeholder="e.g. Weekdays 3–5 PM" />
                </div>
                <div className="form-group">
                  <label htmlFor="modal-message">Add your message</label>
                  <textarea id="modal-message" name="message" rows="4" value={formData.message} onChange={handleChange} placeholder="Your message..." />
                </div>
                <button type="submit" className="btn btn-primary btn-large" disabled={isModalSubmitting}>
                  {isModalSubmitting ? 'Sending...' : 'Submit'}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Home;